import JobPackage from '../../Component/Package/jobPostingPackage'

const PublicJobPackagePage = () => {
    return (
        <>
        <JobPackage/></>
    )
}

export default PublicJobPackagePage